import type { ReactNode } from "react";

export default function KpiCard({
  label,
  value,
  sub,
  accent,
  children,
}: {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  accent?: "positive" | "warn" | "critical" | "accent";
  children?: ReactNode;
}) {
  const valueColor =
    accent === "positive"
      ? "text-positive-700"
      : accent === "warn"
        ? "text-warn-700"
        : accent === "critical"
          ? "text-critical"
          : "text-ink-900";
  return (
    <div className="card p-4">
      <div className="text-xs font-medium uppercase tracking-wide text-ink-500">{label}</div>
      <div className={`mt-1 text-2xl font-semibold tabular-nums ${valueColor}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-ink-500">{sub}</div>}
      {children && <div className="mt-3">{children}</div>}
    </div>
  );
}
